import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'ECommerce|Order History';
const sharedProps = {
	htmlAllowed: false,
	shared: false,
	portal: 'CP' as LocPortal,
	feature: HubFeature.EcommerceShowTransactionHistory,
};

export type EcommerceHistoryLoc =
	| 'CPECommerceHistoryTitle'
	| 'CPECommerceHistoryPageDescription'
	| 'CPECommerceHistoryStatusLabel'
	| 'CPECommerceHistoryIdLabel'
	| 'CPECommerceHistoryDatePurchasedLabel'
	| 'CPECommerceHistoryNameLabel'
	| 'CPECommerceHistoryCodeLabel'
	| 'CPECommerceHistoryTypeLabel'
	| 'CPECommerceHistoryPriceLabel';

export const cpEcommerceHistoryLocs: LocDefs<EcommerceHistoryLoc> = {
	CPECommerceHistoryTitle: {
		defaultValue: 'Purchase History',
		displayType: 'Title',
		description: 'Title for the Order History page',
		displayPath: `${dpRoot}|Title`,
		...sharedProps,
	},
	CPECommerceHistoryPageDescription: {
		defaultValue: '',
		displayType: 'Content',
		description: 'Page description for the Order History page.',
		displayPath: `${dpRoot}|Page Description`,
		...sharedProps,
	},
	CPECommerceHistoryStatusLabel: {
		defaultValue: 'Status',
		displayType: 'Label',
		description: 'Label for the status field in the Order History page.',
		displayPath: `${dpRoot}|Status Label`,
		...sharedProps,
	},
	CPECommerceHistoryIdLabel: {
		defaultValue: 'ID',
		displayType: 'Label',
		description: 'Label for the ID field in the Order History page.',
		displayPath: `${dpRoot}|ID Label`,
		...sharedProps,
	},
	CPECommerceHistoryDatePurchasedLabel: {
		defaultValue: 'Date Purchased',
		displayType: 'Label',
		description: 'Label for the date purchased field in the Order History page.',
		displayPath: `${dpRoot}|Date Purchased Label`,
		...sharedProps,
	},
	CPECommerceHistoryNameLabel: {
		defaultValue: 'Name',
		displayType: 'Label',
		description: 'Label for the name field in the Order History page.',
		displayPath: `${dpRoot}|Name Label`,
		...sharedProps,
	},
	CPECommerceHistoryCodeLabel: {
		defaultValue: 'Code',
		displayType: 'Label',
		description: 'Label for the code field in the Order History page.',
		displayPath: `${dpRoot}|Code Label`,
		...sharedProps,
	},
	CPECommerceHistoryTypeLabel: {
		defaultValue: 'Type',
		displayType: 'Label',
		description: 'Label for the type field in the Order History page.',
		displayPath: `${dpRoot}|Type Label`,
		...sharedProps,
	},
	CPECommerceHistoryPriceLabel: {
		defaultValue: 'Price',
		displayType: 'Label',
		description: 'Label for the price field in the Order History page.',
		displayPath: `${dpRoot}|Price Label`,
		...sharedProps,
	},
};

export const ecommerceHistoryLocKeys = MapLocKeys<EcommerceHistoryLoc>(cpEcommerceHistoryLocs);
export type CpEcommerceHistoryLocType = LocMap<EcommerceHistoryLoc>;
